import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const badges = [
    {
      id: 1,
      icon: 'Shield',
      title: 'DSGVO-konform',
      description: 'Datenschutz-Grundverordnung'
    },
    {
      id: 2,
      icon: 'Lock',
      title: 'BDSG-zertifiziert',
      description: 'Bundesdatenschutzgesetz'
    },
    {
      id: 3,
      icon: 'CheckCircle',
      title: 'BSI-geprüft',
      description: 'Bundesamt für Sicherheit'
    }
  ];

  return (
    <div className="grid grid-cols-3 gap-4">
      {badges?.map((badge) => (
        <div
          key={badge?.id}
          className="flex flex-col items-center text-center p-4 bg-muted/50 rounded-lg border border-border"
        >
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
            <Icon name={badge?.icon} size={24} className="text-primary" />
          </div>
          <h3 className="text-sm font-semibold text-foreground mb-1">
            {badge?.title}
          </h3>
          <p className="text-xs text-muted-foreground">
            {badge?.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;